export const BILLING_SETTINGS_PATH = '/settings?tab=billing';
